import $ from "jquery";

let $body = $('body');

const queryResult = {}

const sortingMenu = () => {

    const $trigger_sort = $('[data-trigger-sort]');
    const $sort__wrapper = $('.sort__wrapper');
    const $sort__overlay = $('.sort__overlay');
    const $sort__close = $('.sort__close');
    const $header__bottom = $('.header__bottom');

    $trigger_sort.on('click', function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $sort__wrapper.removeClass('open');
            $sort__overlay.removeClass('open');
            $body.removeClass('modal__open');
            // setTimeout(function () {
            //     $header__bottom.removeClass('hide');
            // }, 100);
        } else {
            $(this).addClass('open');
            $sort__wrapper.addClass('open');
            $sort__overlay.addClass('open');
            $body.addClass('modal__open');
            // $header__bottom.addClass('hide');
        }
    });

    $sort__close.on('click', function () {
        $trigger_sort.removeClass('open');
        $sort__wrapper.removeClass('open');
        $sort__overlay.removeClass('open');
        $body.removeClass('modal__open');
        // setTimeout(function () {
        //     $header__bottom.removeClass('hide');
        // }, 100);
    });
}


const filterScroll = () => {

    const $filter__mobile = $('.filter__mobile');
    const $filter__mobile_pos = $('.filter__mobile_pos');

    // let position = $(window).scrollTop();

    if ($filter__mobile.length) {

        const filter__pos = $filter__mobile_pos.offset().top;

        scrollPos >= filter__pos ? $filter__mobile.addClass('pinned') : $filter__mobile.removeClass('pinned');

        let scrollPos = $(document).scrollTop();
        let scrollPosLast = $(window).scrollTop();

        window.addEventListener('scroll', function (event) {
            scrollPos = $(window).scrollTop();

            // console.log(scrollPos);

            scrollPos >= filter__pos ? $filter__mobile.addClass('pinned') : $filter__mobile.removeClass('pinned');

            if (scrollPos > scrollPosLast) {
                // console.log('down')
                $filter__mobile.removeClass('down');
            } else {
                // console.log('up')
                $filter__mobile.addClass('down');
            }
            scrollPosLast = scrollPos;
        });


        // $(window).scroll(function(e){
        //     scrollPos = $(document).scrollTop();
        //     scrollPos >= filter__pos ? $filter__mobile.addClass('pinned') : $filter__mobile.removeClass('pinned');
        // });
        //
        // window.addEventListener('wheel', function(event) {
        //     if (event.deltaY < 0) {
        //         $filter__mobile.addClass('down');
        //     }
        //     else if (event.deltaY > 0) {
        //         $filter__mobile.removeClass('down');
        //     }
        // });


    }

};


const filterData = () => {
    const filter_material = $('.filter-material');
    const filter_price = $('.filter-price');
    const filter_attributeValue = $('.filter-attributeValue');
    const $sort_new = $('[data-sort-new]');
    const $sort_price = $('[data-sort-price]');
    const $sort__list_item = $('.sort__list_item');


    const $trigger_sort_text = $('[data-trigger-sort] span');


    let urlResult = window.location
    let urlResponse = urlResult.search

    function getSearchParameters() {
        let prmstr = window.location.search.substr(1);
        return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
    }

    function transformToAssocArray(prmstr) {
        let params = {};
        let prmarr = prmstr.split("&");
        for (let i = 0; i < prmarr.length; i++) {
            let tmparr = prmarr[i].split("=");
            params[tmparr[0]] = tmparr[1];
        }
        return params;
    }

    const responseParams = getSearchParameters();

    for (let param in responseParams) {
        if (Object.prototype.hasOwnProperty.call(responseParams, param)) {
            queryResult[param] = responseParams[param];
        }
    }

    filter_material.change(function (e) {
        let material = []
        filter_material.each(function () {
            if (this.checked && $(this).val() > 0) {
                material.push($(this).val());
            }
        });
        setQueryResult('material', material)
        e.preventDefault();
    });

    filter_price.change(function (e) {
        let price = []
        filter_price.each(function () {
            if (this.checked && $(this).val() > 0) {
                price.push($(this).val());
            }
        });
        setQueryResult('price', price)
        e.preventDefault();
    });

    filter_attributeValue.change(function (e) {
        let attributeValue = []
        filter_attributeValue.each(function () {
            if (this.checked && $(this).val() > 0) {
                attributeValue.push($(this).val());
            }
        });
        setQueryResult('attribute', attributeValue)
        e.preventDefault();
    });

    $(document).on('click', '[data-sort-new]', function (e) {
        // $sort_new.on('click', function () {
        if (!$(this).parent().hasClass('current')) {
            $body.addClass('loading');
            getData('sort', 'new');
        }
    });

    $(document).on('click', '.sort__list_item', function (e) {
        // $sort__list_item.on('click', function () {
        // $body.addClass('loading');
        if (!$(this).parent().hasClass('current')) {
            $sort__list_item.parent().removeClass('current');
            $(this).parent().addClass('current');
            $sort__list_item.removeClass('desc asc');
            $trigger_sort_text.text($(this).text());
        }
    });



    $(document).on('change', '#products__in_stock',function () {
        if($(this).is(':checked')) {
            getStock('stock', 'in-stock');
        } else {
            getStock('stock', 'out-stock');
        }
    });

    $(document).on('click', '[data-sort-price]', function (e) {
        $body.addClass('loading');
        // $sort_price.on('click', function (e) {
        if ($(this).hasClass('desc')) {
            $(this).removeClass('desc');
            $(this).addClass('asc');

            getData('sort', 'asc');
            e.preventDefault();
        } else {
            $(this).removeClass('asc');
            $(this).addClass('desc');

            getData('sort', 'desc');
            e.preventDefault();
        }
        $trigger_sort_text.text($(this).text());
    });

    $(document).on('click', '.products-favorites-pagination a', function (event) {
        event.preventDefault();
        $('li').removeClass('active');
        $(this).parent('li').addClass('active');

        queryResult['page'] = $(this).attr('href').split('page=')[1];

        const urlResult = new URLSearchParams(queryResult).toString().replace(/%2C/g, ",")

        $.ajax({
            url: '?' + urlResult,
            cache: false,

            success: function (data) {
                $products__list.html(data.products);
            }
        });

        window.history.pushState('', '', '?' + urlResult);
        $(window).scrollTop(0);
    });

    $(document).on('click', '.products-pagination a', function (event) {
        event.preventDefault();
        $('li').removeClass('active');
        $(this).parent('li').addClass('active');

        let page = $(this).attr('href').split('page=')[1];
        getData('page', page);
        $(window).scrollTop(0);
    });

    function getStock(key, value) {
        queryResult['page'] = 1;

        $body.addClass('loading');

        if (value != '') {
            queryResult[key] = value;
        } else {
            delete queryResult[key];
        }

        const urlResult = new URLSearchParams(queryResult).toString().replace(/%2C/g, ",")
        // body...
        $.ajax({
            url: '?' + urlResult,
            type: 'get',
            datatype: 'html',
        }).done(function (data) {
            $body.removeClass('loading');
            if (data.success == true) {
                $products__list.html(data.products).removeClass('loading');
                $(window).scrollTop(0);

                if (data.countFilteredProducts == 0) {
                    $sorting__wrap.addClass('d-none');
                    $('#no-products').hide();
                    $products__list_empty.removeClass('d-none');
                } else {
                    $products__list_empty.addClass('d-none');
                    $sorting__wrap.removeClass('d-none');
                    $products__list.removeClass('d-none');
                }
            }
        }).fail(function (jqXHR, ajaxOptions, thrownError) {
            $body.removeClass('loading');
            alert('No response from server');
        });
        window.history.pushState('', '', '?' + urlResult);
    }

    function getData(key, value) {
        queryResult['page'] = 1;

        if (value != '') {
            queryResult[key] = value;
        } else {
            delete queryResult[key];
        }

        const urlResult = new URLSearchParams(queryResult).toString().replace(/%2C/g, ",")
        // body...
        $.ajax({
            url: '?' + urlResult,
            type: 'get',
            datatype: 'html',
        }).done(function (data) {
            // console.log(data)
            $body.removeClass('loading');
            if (data.success == true) {
                $products__list.html(data.products).removeClass('loading');
                $(window).scrollTop(0);

                let window_w = $(window).width();
                if (window_w < 992) {
                    $('.sort__close').click();
                }
            }
        }).fail(function (jqXHR, ajaxOptions, thrownError) {
            alert('No response from server');
        });
        window.history.pushState('', '', '?' + urlResult);
    }

    const $products__list = $('.products__list');
    const $sorting__wrap = $('.sorting__wrap');
    const $products__list_empty = $('.products__list_empty');

    function setQueryResult(key, value) {
        $body.addClass('loading');
        queryResult['page'] = 1;

        if (value != '') {
            queryResult[key] = value;
        } else {
            delete queryResult[key];
        }
        const urlResult = new URLSearchParams(queryResult).toString().replace(/%2C/g, ",")

        const urlParams = new URLSearchParams('?' + urlResult);

        const page_price = urlParams.get('price');
        const page_material = urlParams.get('material');
        const page_attribute = urlParams.get('attribute');

        delay(function () {
            $.ajax(
                {
                    url: '?' + urlResult,
                    cache: false,
                }).done(function (data) {

                $body.removeClass('loading');
                if (data.success == true) {
                    $products__list.html(data.products).removeClass('loading');
                    $('.result__current').text(data.countFilteredProducts);
                    $('.words-filter').html(data.text);
                    $('.result__all').text(data.countProducts);

                    if (page_price != null || page_material != null || page_attribute != null) {
                        $('.filtered-block').addClass('d-lg-block');
                        $('.result__info').removeClass('d-none');
                    } else {
                        $('.filtered-block').removeClass('d-lg-block');
                        $('.result__info').addClass('d-none');
                    }

                    $(window).scrollTop(0);
                }

                if (data.countFilteredProducts == 0) {
                    $sorting__wrap.addClass('d-none');
                    $('#no-products').hide();
                    $products__list_empty.removeClass('d-none');
                } else {
                    $products__list_empty.addClass('d-none');
                    $sorting__wrap.removeClass('d-none');
                    $products__list.removeClass('d-none');
                }
            })
        }, 500);
        window.history.pushState('', '', '?' + urlResult);
    }
}

sortingMenu()
filterScroll()

filterData()
